import $ from 'jquery';
// import mpro from './mpro.init';

import MpDrawer from '../../modules/components/drawer.js';
import MpModal from '../../modules/components/modal.js';
import {
	applyComponentClickRestrictions,
	getOptionsFromDataset,
} from '../../util/dom.js';

// Add init function that is executed only on first dom-ready (it should contain only document/body delegate handlers)
mpro.addInitDelegate(($) => {

	const $B = mpro.get$B();

	// Modal Clicks
	$B.on('click.mp-overlay', '[data-overlay]', function(e) {

		/** @type {HTMLElement} */
		const elem = this;

		// This is a tick counter overlay element, ignore
		if (elem.closest('[class*="tick"], [data-counter]')) {
			return;
		}

		const options = getOptionsFromDataset(elem, 'overlay', true);

		// Standard component click restrictions
		if (applyComponentClickRestrictions('overlay', options, e) === false) {
			return;
		}

		// Get dataset options
		const mode = (options.modeMobile && mpro.isMobileScreen()) || options.mode || 'modal';

		// Close toasts and similar overlays
		mpro.closeSimpleOverlays();

		// Display drawer
		if (mode === 'drawer') {
			// Display the instance
			MpDrawer.show({
				relatedTarget: elem,
				url: elem.getAttribute('href'),
				// Allow data-drawer attributes to also be parsed
				skipDataset: false,
				...options,
			});
		}
		// Display modal
		else {
			// Display the instance
			MpModal.show({
				relatedTarget: elem,
				url: elem.getAttribute('href'),
				// Allow data-modal attributes to also be parsed
				skipDataset: false,
				...options,
			});
		}
	});
});

export default mpro;
